import { Select } from '@creditornot/cb-select';
import React, { useMemo } from 'react';
import { Field, useField } from 'react-final-form';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { RFFFieldErrorWrapper } from 'common/components';
import InputNumber from 'common/components/InputNumber';

import { FormValues } from './types';

const BREAKPOINT = 440;

const InputsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  justify-content: space-between;
  > * {
    flex-grow: 1;
  }

  @media (min-width: ${BREAKPOINT}px) {
    flex-direction: row;
  }
`;

type CaffeineContentFieldsProps = {
  autoFocus?: boolean;
};

export const CaffeineContentFields = ({ autoFocus }: CaffeineContentFieldsProps) => {
  const intl = useIntl();
  const caffeineContentValueField = useField<FormValues['caffeineContentValue']>('caffeineContentValue');
  const caffeineContentUnitsField = useField<FormValues['caffeineContentUnits']>('caffeineContentUnits');
  const caffeineOptions = useMemo(
    () => [
      { value: 'mg_per_100_g', label: intl.formatMessage({ id: 'menu-item.caffeine-baseline-100g' }) },
      {
        value: 'mg_per_100_ml',
        label: intl.formatMessage({ id: 'menu-item.caffeine-baseline-100ml' }),
      },
    ],
    [intl],
  );

  return (
    <div>
      <InputsWrapper>
        <Field<number> name="caffeineContentValue">
          {field => (
            <RFFFieldErrorWrapper field={field}>
              {input => (
                <InputNumber
                  {...input}
                  name="caffeineContentValue"
                  onChange={value => {
                    input.onChange(value);

                    if (!value) {
                      caffeineContentUnitsField.input.onChange(undefined);
                      return;
                    }

                    if (!caffeineContentUnitsField.input.value) {
                      caffeineContentUnitsField.input.onChange('mg_per_100_g');
                    }
                  }}
                  suffixText={intl.formatMessage({ id: 'menu-item.caffeine-baseline-unit' })}
                  autoFocus={autoFocus}
                />
              )}
            </RFFFieldErrorWrapper>
          )}
        </Field>

        <Field<string> name="caffeineContentUnits">
          {field => (
            <RFFFieldErrorWrapper field={field}>
              {input => (
                <Select
                  {...input}
                  options={caffeineOptions}
                  onBlur={() => {
                    if (!caffeineContentValueField.input.value) {
                      caffeineContentUnitsField.input.onChange(undefined);
                    }
                  }}
                />
              )}
            </RFFFieldErrorWrapper>
          )}
        </Field>
      </InputsWrapper>
    </div>
  );
};
